module.exports = __webpack_public_path__ + "img/hero_sp.438c3427.jpg";